import { render, staticRenderFns } from "./HostHosGtest.vue?vue&type=template&id=52a202b6&scoped=true&"
import script from "./HostHosGtest.vue?vue&type=script&lang=js&"
export * from "./HostHosGtest.vue?vue&type=script&lang=js&"
import style0 from "./HostHosGtest.vue?vue&type=style&index=0&id=52a202b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a202b6",
  null
  
)

export default component.exports